export default __webpack_public_path__ + "static/media/Boye (5).cee25a5b.jpg";